var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"containerT"}},_vm._l((30),function(i){return _c('grid-item',{key:i})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }